"use stricts"
AriaTablist(document.getElementById('languages'));